export default __webpack_public_path__ + "static/media/NorthAmerica_01.5df053c5.png";